export const InstallFooter = {
  flow: 'x',
  align: 'center',
  gap: 'X2',
  opacity: '.35',
  Icon: {
    name: 'question mark fill'
  },
  Paragraph: {
    margin: '0',
    childrenAs: 'props',
    children: [
      {
        text: '{{ learn.install.footer | polyglot }}',
        padding: '0 V1'
      },
      {
        extends: 'DocsLink',
        href: '/docs/intro',
        text: '{{ learn.install.docsPage | polyglot }}'
      }
    ]
  }
}
